export type DifficultyId = "easy" | "normal" | "hard";

export interface DifficultyDefinition {
  readonly id: DifficultyId;
  readonly label: string;
  readonly minTarget: number;
  readonly maxTarget: number;
  readonly boardSize: 4 | 6;
  readonly icon: string;
  readonly color: string;
}

export const GAME_MANIFEST = Object.freeze({
  id: "futatsu-de-pittari",
  title: "ふたつで ぴったり",
  category: "かず",
  targetAge: "しょうがく1ねんせい",
  description: "ふたつの かずを たして、ぴったりの かずを つくろう！",
});

export const DIFFICULTIES: Readonly<Record<DifficultyId, DifficultyDefinition>> = Object.freeze({
  easy: Object.freeze({
    id: "easy",
    label: "やさしい",
    minTarget: 5,
    maxTarget: 10,
    boardSize: 4,
    icon: "●",
    color: "#38b789",
  }),
  normal: Object.freeze({
    id: "normal",
    label: "ふつう",
    minTarget: 8,
    maxTarget: 15,
    boardSize: 6,
    icon: "▲",
    color: "#e29b32",
  }),
  hard: Object.freeze({
    id: "hard",
    label: "むずかしい",
    minTarget: 11,
    maxTarget: 20,
    boardSize: 6,
    icon: "★",
    color: "#8a69dc",
  }),
});

export const DIFFICULTY_ORDER: readonly DifficultyId[] = ["easy", "normal", "hard"];
